import { CanActivateFn } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { of, switchMap, take } from 'rxjs';

@Injectable()
export class AuthInitializationGuard {
  constructor(private authService: AuthService) {}

  canActivate: CanActivateFn = () => {
    return this.authService.isInitialized$.pipe(
      take(1),
      switchMap((initialized) => {
        if (!initialized) {
          this.authService.initializeAuthState();
          return of(true);
        }

        return of(true);
      }),
    );
  };
}
